import React, { PropsWithChildren } from 'react'

import * as styles from './SidenavContentNavGroup.style'

export interface SidenavContentNavGroupProps {
  header?: string
  isSidenavOpen: boolean
}

const SidenavContentNavGroup: React.FC<
  PropsWithChildren<SidenavContentNavGroupProps>
> = (props): React.ReactElement => {
  return (
    <div css={styles.navGroup}>
      {props.header && (
        <div
          css={styles.navGroupHeader}
          className={props.isSidenavOpen ? 'open' : 'closed'}
        >
          <span
            css={styles.navHeaderText}
            className={props.isSidenavOpen ? 'open' : 'closed'}
          >
            {props.header}
          </span>
        </div>
      )}
      {props.children}
    </div>
  )
}

export default SidenavContentNavGroup
